/* eslint-disable */
import { StyleSheet ,Platform} from 'react-native'

import {ifIPhoneX} from '../../Lib/utils'
import { Fonts, ApplicationStyles} from   '../../Themes'
export default StyleSheet.create({

  navbar : {
    backgroundColor: Fonts.style.color.navbar
  },
  online : {
    flexDirection: 'row',
    flex: 1,
     alignItems: 'center',
    alignSelf: 'center'
  },
  onlineImage: {
    marginTop: 2,
    width: 15,
    height: 15,
    marginRight: 5
  },
  statusBar: {
    ...Platform.select({
      ios: ifIPhoneX({ height: 44 /*31*/ }, { height: 20 }), // 44 (60 in prod 1.79)
      android: { height: 0  },
    }),
    backgroundColor: '#FFFFFF',

  },

  content: {
    height: 44,
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',

    borderBottomWidth: 1,
    borderBottomColor: '#d3d3d3',
  },

  leftButtons: {
    position: 'absolute',
  },

  rightButtons: {
    position: 'absolute',
    right: 0,
  },
  tinColor : {
    tintColor: Fonts.style.color.baseColor
  },
  image : {
    width: 20,
    height: 20,
    // tintColor: Fonts.style.color.baseColor
  },
  titleWhite: {
    alignSelf: 'center',
    backgroundColor: 'transparent',
    color: Fonts.style.color.white,
    fontFamily:Fonts.style.font.light,
    fontSize: 17,
    paddingBottom: 2,
  },
  titleBlack: {

    backgroundColor: 'transparent',
    color: Fonts.style.color.black,
    fontFamily:Fonts.style.font.bold,
    fontSize: 17,
    paddingBottom: 2,
  },
  logo: {
    alignSelf: 'center',
    height : 30 ,
    width: 120,
    marginTop: 5

  },

  button: {
    padding: 14,
    backgroundColor: 'transparent',
  },

  buttonTitle: {
    color: Fonts.style.color.baseColor,
    fontFamily: Fonts.style.font.regular,
    fontSize: 16,
  },
})
